import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useFeatureFlag } from '../../contexts/featureFlagContext';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { useProjectVolumes } from '../../hooks/useProjectVolumes';
import { useProposalProject } from '../../hooks/useProposalProject';
import { useLayoutStore } from '../../lib/stores/LayoutStore';
import { buildProposalNavGroups, proposalSubtitle } from './proposalNav';
import { RecordSidebar } from './RecordSidebar';
import { useCanReadProposalPricing } from './useCanReadProposalPricing';
import { useProposalNavCounts } from './useProposalNavCounts';
import { useProposalPursuit } from './useProposalPursuit';
/** Proposal record rail (FND-20, §4.3). */ export function ProposalSidebar({ projectId }) {
    const { data } = useProposalProject(projectId);
    const volumesQuery = useProjectVolumes(projectId);
    const counts = useProposalNavCounts(projectId);
    const pursuit = useProposalPursuit(projectId);
    const canReadPricing = useCanReadProposalPricing(projectId);
    const documentsHub = useFeatureFlag('proposal_documents_hub_v1') === true;
    const location = useLocation();
    const assistOpen = useLayoutStore((s)=>s.assistOpen);
    const assistHost = useLayoutStore((s)=>s.assistHost);
    const narrowDesktop = useMediaQuery('(max-width: 1439px)');
    // Make room for ONLYOFFICE: collapse the rail (not persisted) while a volume is open with the proposal AI pane.
    const autoCollapsed = assistOpen && assistHost === 'page' && narrowDesktop && location.pathname.includes('/v2/volume/');
    const [volumesExpanded, setVolumesExpanded] = useState(false);
    const groups = useMemo(()=>buildProposalNavGroups({
            volumes: volumesQuery.data ?? [],
            volumesLoading: volumesQuery.isLoading,
            volumesExpanded,
            onToggleVolumes: ()=>setVolumesExpanded((v)=>!v),
            documentsHub,
            hasPursuit: Boolean(pursuit),
            canReadPricing
        }), [
        volumesQuery.data,
        volumesQuery.isLoading,
        volumesExpanded,
        documentsHub,
        pursuit,
        canReadPricing
    ]);
    return /*#__PURE__*/ _jsx(RecordSidebar, {
        autoCollapsed: autoCollapsed,
        back: pursuit ? {
            label: pursuit.name,
            href: pursuit.href
        } : {
            label: 'Projects',
            href: '/projects'
        },
        basePath: `/proposal/${projectId}/v2`,
        counts: counts,
        groups: groups,
        name: data?.project.name || 'Proposal',
        navigationLabel: "Proposal navigation",
        subtitle: proposalSubtitle(data?.project)
    });
}
